export default {
    init() {
        // JavaScript to be fired on the home page
        var myslider = jQuery('.flexslider');
        $(myslider).flexslider({
            slideshow: true,
            animationSpeed: 1000,
            slideshowSpeed: 5000,
            animation: 'fade',
            directionNav: true,
        });
        // code for resize flexslider
        $(window).bind('resize', function() {
            setTimeout(function() {
                var slider = $(myslider).data('flexslider');
                slider.resize();
            }, 1000);
        });        
        jQuery('.icons_slider').slick({
            dots: false,
            arrows: false,
            infinite: false,
            speed: 300,
            adaptiveHeight: true,
            centerMode: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 768,
                settings: {
                    arrows: true,
                    centerMode: false,
                    slidesToShow: 1,
                    prevArrow: '<img class="a-left control-c prev slick-prev" src="/wp-content/uploads/2021/04/Union-13.png">',
                    nextArrow: '<img class="a-right control-c next slick-next" src="/wp-content/uploads/2021/04/Union-1.png">',
                },
            }],
        });

    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};


// WEBPACK FOOTER //
// ./scripts/routes/home.js